import React, { useState } from 'react';
import { Tabs, Typography } from 'antd';
import { UserOutlined, LockOutlined, BgColorsOutlined, DollarOutlined } from '@ant-design/icons';
import SettingsProfile from './Profile/Profile';
import SettingsSecurity from './Security/Security';
import SettingsBranding from './Branding';
import SettingsPricing from './Pricing';

const { Title } = Typography;

const Settings = () => {
  const [activeTab, setActiveTab] = useState('profile');

  const items = [
    {
      key: 'profile',
      label: (
        <span>
          <UserOutlined /> Enterprise Profile
        </span>
      ),
      children: <SettingsProfile />
    },
    {
      key: 'security',
      label: (
        <span>
          <LockOutlined /> Security & Access Control
        </span>
      ),
      children: <SettingsSecurity />
    },
    {
      key: 'branding',
      label: (
        <span>
          <BgColorsOutlined /> White Label Branding
        </span>
      ),
      children: <SettingsBranding />
    },
    {
      key: 'pricing',
      label: (
        <span>
          <DollarOutlined /> Pricing Controls
        </span>
      ),
      children: <SettingsPricing />
    }
  ];

  return (
    <div style={{ padding: '24px' }}>
      <Title level={2}>Settings</Title>
      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        items={items}
        size="large"
      />
    </div>
  );
};

export default Settings;
